import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";





import "swiper/css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "./Spinner.js";


export default function PicksForYouSlider() {
  const swiperRef = useRef(null);

 const [products, setProducts] = useState([]);
 const [loading, setLoading] = useState(true);

 const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    axios
      .get(API_URL+"products")
      .then((res) => {
        if (res.data.status) {
          setProducts(res.data.data);
          
          
        } else {
          setProducts(null);
          
        }
        setLoading(false);
        
      })
      .catch((err) => {
        console.error("Failed to load colors", err);
        setLoading(false);
      });
  }, []);


  if (loading) return <Spinner />;
  

  return (
    <div className="container">
      <div className="row mt-5 mb-5">
        <div className="col-12 position-relative">

          {/* LEFT NAVIGATION BUTTON */}
          <button
            onClick={() => swiperRef.current.slidePrev()}
            style={{
              position: "absolute",
              top: "50%",
              left: "60px",
              transform: "translateY(-50%)",
              background: "#fff",
              borderRadius: "50%",
              border: "1px solid #ddd",
              width: "48px",
              height: "48px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
              cursor: "pointer",
            }}
          >
            {/* LEFT ARROW */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 18l-6-6 6-6"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {/* RIGHT NAVIGATION BUTTON */}
          <button
            onClick={() => swiperRef.current.slideNext()}
            style={{
              position: "absolute",
              top: "50%",
              right: "60px",
              transform: "translateY(-50%)",
              background: "#fff",
              borderRadius: "50%",
              border: "1px solid #ddd",
              width: "48px",
              height: "48px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
              cursor: "pointer",
            }}
          >
            {/* RIGHT ARROW */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 6l6 6-6 6"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {/* SWIPER */}
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            centeredSlides={true}
              breakpoints={{
              0: {
                slidesPerView: 1,   // Mobile
              },
              576: {
                slidesPerView: 2,   // Small devices
              },
              768: {
                slidesPerView: 3,   // Tablets
              },
              992: {
                slidesPerView: 5,   // Desktop
              },
            }}
            loop={true}
            spaceBetween={20}
            >
            {products.map((item, i) => (
              <SwiperSlide key={i}>
                <div style={{ textAlign: "center" }}>
                    <Link to={`/product/${item.slug}`}  style={{ textDecoration: "none", color: "inherit" }}>
                  <img
                    src={item.primary_image.image_url}
                    alt="slide"
                    width={880}
                    height={880}
                    style={{
                      width: "100%",
                      maxWidth: "880px",
                      height: "auto",
                      borderRadius: "12px",
                      objectFit: "cover",
                      margin: "0 auto",
                    }}

                    
                  />

                                  {/* PRODUCT TITLE */}
                  <p
                    style={{
                      marginTop: "12px",
                      fontSize: "14px",
                      fontWeight: "700",
                      lineHeight:"1.5",
                      letterSpacing:"0.05em",
                      fontFamily:"'Figs', 'Raleway', sans-serif"
                    }}
                  >
                    {item.name}
                  </p>

                  {/* PRICE IN INR */}
                  <p
                    style={{
                      marginTop: "4px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    {item.catalogue_no}
                  </p>
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>
    </div>
  );
}
